module.exports = __webpack_public_path__ + "static/media/migration_vector.b66ca14e.png";